var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _circle2, _circle3, _rect2, _path11, _rect3, _path12, _circle4, _path13, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path14, _rect12, _ellipse, _rect13, _rect14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4850822-491f-41e2-90b8-9be7376dfe8f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 798.62718,
    height: 689.22258,
    viewBox: "0 0 798.62718 689.22258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dev_productivity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 435.92153,
    cy: 118.40512,
    r: 73.53607,
    fill: "#a0616a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M581.7223,260.56187s13.8546,104.44259-7.46016,116.16564,126.8231,12.78888,126.8231,12.78888S668.0473,298.9285,682.96762,271.21921Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M809.25666,390.04472l-12.32,56.1-26.05,118.69-.78,6.5-8.99,75.25-5.98,49.99-4.01,33.58c-24.38,12.53-42.05,21.18-42.05,21.18s-1.52-7.62-3.97-17.37c-17.11,5.13-48.77,13.64-75.6,15.34,9.77,10.89,14.26,21.12,8.17,28.67-18.38,22.76-94.26-24.92-120.8-42.7a71.84076,71.84076,0,0,0-.7,12.86l-20.31-15.62,2.01-35.94,3.39-60.81,4.26-76.26a80.06413,80.06413,0,0,1-3.37-10.03c-6.22-22.12-13.77-66.29-19.56-103.33-4.66-29.81-8.16-55-8.9-60.36-.1-.7-.15-1.06-.15-1.06l112.43-49.68c7.99,18.53,45.30005,24.1,45.30005,24.1,30.91-2.13,55.14-18.43,55.14-18.43Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#d0cde1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M717.60664,730.02476s-4.76,1.63-12.5,3.94c-17.11,5.13-48.77,13.64-75.6,15.34-23.1,1.48-42.62-2.08-46.19-17.15-1.53-6.48.64-11.81,5.37-16.19,14.12-13.09,51-17.78,80.25-19.39,8.26-.45,15.9-.66,22.26-.74,10.8-.14,17.88.08,17.88.08l.17.66Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M575.43275,154.23549,561.6833,148.731s28.74878-31.65079,68.74742-28.89843l-11.24986-12.38521s27.49889-11.00886,52.49786,17.88956c13.14149,15.19123,28.34631,33.04782,37.82491,53.163h14.72472l-6.14554,13.53179,21.50942,13.5318-22.07731-2.43059a75.61673,75.61673,0,0,1,.5991,22.445A29.04072,29.04072,0,0,1,707.4796,244.5758h0s-17.05183-35.29562-17.05183-40.80013V217.5369s-13.74944-12.38505-13.74944-20.64172L669.1787,206.528l-3.74981-15.13741-46.248,15.13741,7.49962-12.385-28.74878,4.12833,11.24986-15.13741s-32.49859,17.88956-33.74881,33.027c-1.24979,15.1372-10.76227,29.48068-10.76227,29.48068S539.18426,174.8772,575.43275,154.23549Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M889.18665,647.95475c-7.49,8.12-26.05,20.35-48.55,33.59-8.37,4.92-17.28,9.99-26.37,15.03-21.69,12.03-44.4,23.95-63.14,33.58-24.38,12.53-42.05,21.18-42.05,21.18s-1.52-7.62-3.97-17.37c-3.28-13.05-8.22-29.92-13.37-37.39-.18-.26-.36-.5-.54-.74-1.5-1.97-3.01-3.12-4.5-3.12l74.42-46.13,32.16-19.94-23.17-55.31-29.06-69.38,17.54-55.81,17.63-56.1h33.04s10.94,23.88,24.93,57.18005c2.09,4.98,4.25,10.17,6.45,15.53C869.41664,532.75474,905.29664,630.50474,889.18665,647.95475Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#d0cde1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M637.67664,777.97477c-18.38,22.76-94.26-24.92-120.8-42.7-5.78-3.87-9.22-6.32-9.22-6.32l24.28-32.38,7.69-10.25s6.88,3.65,17.05,9.59c.37.22.74.44,1.12.66,8.77,5.15,19.78,11.88,30.89,19.39,15.33,10.37,30.83,22.2,40.82,33.34C639.27668,760.19474,643.76667,770.42472,637.67664,777.97477Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M556.67664,695.91477a47.78152,47.78152,0,0,0-8.1.66c-22.99,3.95-29.77,24.76-31.7,38.7a71.84076,71.84076,0,0,0-.7,12.86l-20.31-15.62-7.4-5.69c-17.81-6.21-33.68-17.24-47.44-30.25a238.48245,238.48245,0,0,1-31.95-37.89,334.15026,334.15026,0,0,1-24.72-42.4,31.18368,31.18368,0,0,1-.43-26.45l25.15-56.05,36.76-81.92q.40494-2.92492.88995-5.72c7.29-41.8,26.82-60.36,26.82-60.36h14.92l9.98,60.36,12.4,74.99-8.69,28.34-20.08,65.44995,19.19,20.84Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#d0cde1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M573.563,521.19459l12.75489,14.88081c4.73879-.90351,9.68742-1.96527,14.78434-3.15766l-3.66344-11.72315,8.9575,10.45044c53.9974-13.28079,120.92677-39.10138,120.92677-39.10138s-72.25715,5.29821-126.20826-6.48861c-23.87075-5.21509-48.43073,6.61811-58.22631,29.0024-5.69358,13.01063-4.7994,24.28275,15.394,24.28275a133.3748,133.3748,0,0,0,20.35271-1.91438Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#93c5fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M864.33668,765.77476v6.07a13.34012,13.34012,0,0,1-.91,4.87,13.68758,13.68758,0,0,1-.97,2,13.43748,13.43748,0,0,1-11.55,6.56h-446.55a13.4374,13.4374,0,0,1-11.55-6.56,13.68249,13.68249,0,0,1-.97-2,13.34012,13.34012,0,0,1-.91-4.87v-6.07a13.42641,13.42641,0,0,1,13.43-13.43h25.74v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.38995v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.4v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.39v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.39v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.4v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.39v-2.83a.55908.55908,0,0,1,.56-.56h105.2a.55908.55908,0,0,1,.56.56v2.83h8.4v-2.83a.55908.55908,0,0,1,.56-.56h13.43005a.56556.56556,0,0,1,.56.56v2.83h8.39v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55909.55909,0,0,1,.56005.56v2.83h8.39v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.4v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.557.557,0,0,1,.55.56v2.83h8.4v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h8.39v-2.83a.55908.55908,0,0,1,.56-.56h13.43a.55908.55908,0,0,1,.56.56v2.83h39.17A13.42642,13.42642,0,0,1,864.33668,765.77476Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.50024,
    y: 671.32605,
    width: 732.99951,
    height: 2,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M828.38091,510.14529H661.938v-3.43053H586.46634v3.43053h-167.129a11.25861,11.25861,0,0,0-11.25861,11.25861V749.3154a11.25864,11.25864,0,0,0,11.25861,11.25865H828.38091a11.25864,11.25864,0,0,0,11.25861-11.25865V521.4039A11.2586,11.2586,0,0,0,828.38091,510.14529Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.50024,
    cy: 484.32605,
    r: 25,
    fill: "none",
    stroke: "#d0cde1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 415.50024,
    cy: 493.32605,
    r: 25,
    fill: "#d0cde1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.44606,
    y: 661.22258,
    width: 28,
    height: 28,
    fill: "#d0cde1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.13642,744.6117v34h34v-34Zm32.52,32.52h-31.05v-31.04h31.05Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 728.44606,
    y: 661.22258,
    width: 28,
    height: 28,
    fill: "#d0cde1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M940.13642,744.6117v34h34v-34Zm32.52,32.52h-31.05v-31.04h31.05Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.58008,
    cy: 150.77286,
    r: 79.34043,
    fill: "#93c5fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M322.91543,161.87871a85.75482,85.75482,0,0,0-21.6383,0A84.36847,84.36847,0,0,0,231.662,220.59058a83.22288,83.22288,0,0,0-3.65452,21.66236c-.036,1.02178-.06009,2.05567-.06009,3.08948a84.23318,84.23318,0,0,0,84.14894,84.14894c1.79116,0,3.58232-.06009,5.34948-.16832a83.2307,83.2307,0,0,0,12.33384-1.707,84.15894,84.15894,0,0,0-6.86417-165.73733Zm15.51943,160.8567h-.012a80.90778,80.90778,0,0,1-20.97714,4.17134c-1.76716.12026-3.55832.18035-5.34948.18035a81.84489,81.84489,0,0,1-81.74468-81.74468c0-1.03381.02406-2.0677.06009-3.08948a81.85576,81.85576,0,0,1,81.68459-78.6552,81.74921,81.74921,0,0,1,26.33858,159.13767Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110.20774,
    y: 63.01754,
    width: 2.40426,
    height: 16.82979,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 262.44229,
    y: 188.47567,
    width: 2.40426,
    height: 16.82979,
    transform: "translate(-262.6894 138.70396) rotate(-45)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 242.37287,
    y: 236.92753,
    width: 2.40426,
    height: 16.82979,
    transform: "translate(-202.45383 383.52871) rotate(-90)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 262.44229,
    y: 285.37939,
    width: 2.40426,
    height: 16.82979,
    transform: "translate(41.63884 582.57426) rotate(-135)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 359.34601,
    y: 188.47567,
    width: 2.40426,
    height: 16.82979,
    transform: "translate(275.58511 485.67054) rotate(-135)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 379.41543,
    y: 236.92753,
    width: 2.40426,
    height: 16.82979,
    transform: "translate(-65.41128 520.57127) rotate(-90)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 359.34601,
    y: 285.37939,
    width: 2.40426,
    height: 16.82979,
    transform: "translate(-302.82823 235.60768) rotate(-45)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 110.20774,
    y: 200.0601,
    width: 2.40426,
    height: 16.82979,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.70266,240.53391a6.01062,6.01062,0,0,0-7.21276,0,6.18721,6.18721,0,0,0-1.719,2.01957,6.01117,6.01117,0,1,0,8.9318-2.01957Zm-3.60638,8.41489a3.617,3.617,0,0,1-3.60638-3.60638,3.67121,3.67121,0,0,1,.63716-2.04363,3.60288,3.60288,0,1,1,2.96922,5.65Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 100.59072,
    y: 35.36861,
    width: 21.6383,
    height: 21.6383,
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.40987,
    cy: 28.7569,
    rx: 28.85106,
    ry: 10.21809,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 107.80348,
    y: 94.27286,
    width: 7.21277,
    height: 40.87234,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    y: 220.44007,
    width: 226,
    height: 2.40426,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M351.28007,705.14275c.93308,31.95-17.73513,43.65892-41.1632,44.34312q-.81629.02383-1.62524.02922-1.62969.01242-3.22774-.05428c-21.18834-.87961-37.96015-12.12685-38.82791-41.84025-.898-30.74968,37.26893-70.70292,40.1325-73.65827l.00511-.00276c.10878-.11262.16448-.169.16448-.169S350.34707,673.19538,351.28007,705.14275Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#d0cde1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M308.43014,744.64381l14.88232-22.1315-14.85188,24.51243.031,2.49035q-1.62969.01242-3.22774-.05428L306.002,717.449l-.02022-.247.02723-.04771.07065-3.02493-16.2979-23.66265,16.27867,21.39867.05777.63938.55752-24.18618-14.077-24.53275,14.11708,20.28394-.14735-50.10752.00032-.16678.00479.164.93446,39.49147,12.8295-16.04146-12.7875,19.44356.28,21.634,11.80578-21.11394-11.76239,24.29451.15587,12.02957,17.16879-29.41146-17.11659,33.60807Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M999.28007,705.14275c.93308,31.95-17.73513,43.65892-41.1632,44.34312q-.81628.02383-1.62524.02922-1.62969.01242-3.22774-.05428c-21.18834-.87961-37.96015-12.12685-38.82791-41.84025-.898-30.74968,37.26893-70.70292,40.1325-73.65827l.00511-.00276c.10878-.11262.16448-.169.16448-.169S998.34707,673.19538,999.28007,705.14275Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#d0cde1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M956.43014,744.64381l14.88232-22.1315-14.85188,24.51243.031,2.49035q-1.62969.01242-3.22774-.05428L954.002,717.449l-.02022-.247.02723-.04771.07065-3.02493-16.2979-23.66265,16.27867,21.39867.05777.63938.55752-24.18618-14.077-24.53275,14.11708,20.28394-.14735-50.10752.00032-.16678.00479.164.93446,39.49147,12.8295-16.04146-12.7875,19.44356.28,21.634,11.80578-21.11394-11.76239,24.29451.15587,12.02957,17.16879-29.41146-17.11659,33.60807Z",
    transform: "translate(-200.68641 -105.38871)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.49cdf78d9084f6b4ead6117dc51acc59.svg";
export { ForwardRef as ReactComponent };